export default {
  submitBtnTitle: {
    en: 'Submit',
  },
}
